// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__25n36","content":"styles_content__1HBHm","selectAll":"styles_selectAll__2yTzq"};